import { Component, OnInit, Input, OnDestroy, OnChanges } from '@angular/core';
import { Product } from '../../models/product.model';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Subscription, Observable } from 'rxjs';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { trigger, transition } from '@angular/animations';
import { Item } from '../../models/item.model';

@Component({
  selector: 'app-item-list',
  templateUrl: './item-list.component.html',
  styleUrls: ['./item-list.component.scss'],
  animations: [
    trigger('blockInitialRenderAnimation', [transition(':enter', [])])
  ]
})
export class ItemListComponent implements OnInit, OnDestroy, OnChanges {

  private subscriptions = new Map<string, Subscription>();

  @Input() items: Item[] = [];
  @Input() readOnly = false;
  @Input() loading$: Observable<boolean>;
  @Input() expandAll = false;
  locale: string;
  desktop = true;
  disableAnimation = false;

  constructor(
    private translate: TranslateService,
    private mediaObserver: MediaObserver,
  ) { }

  ngOnInit() {
    this.disableAnimation = !this.desktop || this.items && this.items.length > 10;

    // language changes
    this.subscriptions.set('translationLanguageChanged',
      this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.locale = event.lang;
      })
    );

    // listen for browser size changes
    this.subscriptions.set('mediaViewportChanged',
      this.mediaObserver.asObservable().subscribe((changes: MediaChange[]) => {
        const change = changes.pop();
        if (change) {
          this.desktop = !(change.mqAlias === 'xs' || change.mqAlias === 'sm');
        }
      })
    );

  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  ngOnChanges() {
    this.disableAnimation = !this.desktop || this.items && this.items.length > 10;
  }

  trackByFn = (index: number, item: Product) => item.code;

}
